module.exports = {
  LOHN: { api: 'LOHN', human: 'Lohn' },
  MATERIAL: { api: 'MATERIAL', human: 'Material' }
}
